import React from 'react';
import { motion } from 'framer-motion';

export default function AsciiPreview({ ascii, color }) {
  return (
    <div className="relative bg-zinc-950 border border-zinc-800 rounded overflow-hidden">
      <div className="flex items-center gap-1.5 px-3 py-2 border-b border-zinc-800 bg-zinc-900/50">
        <div className="w-2 h-2 rounded-full bg-rose-500/60" />
        <div className="w-2 h-2 rounded-full bg-amber-500/60" />
        <div className="w-2 h-2 rounded-full bg-emerald-500/60" />
        <span className="ml-2 text-[9px] text-zinc-500 tracking-widest uppercase">preview.ascii</span>
      </div>
      <div className="relative p-6 min-h-[200px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 scanline opacity-20 pointer-events-none" />
        <motion.pre
          key={ascii + color}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
          className="text-[10px] md:text-xs leading-tight font-mono whitespace-pre relative z-10"
          style={{ color: color || '#06b6d4', textShadow: `0 0 8px ${color || '#06b6d4'}80` }}
        >
          {ascii}
        </motion.pre>
      </div>
    </div>
  );
}